"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var util_localization_1 = require("@sport-thieme/util-localization");
var react_ui_1 = require("@sport-thieme/react-ui");
var aws_amplify_1 = require("aws-amplify");
var aws_exports_1 = require("./aws-exports");
var language = aws_exports_1.languages.de;
function SignIn() {
    var _this = this;
    var _a = (0, react_1.useState)(""), error = _a[0], setError = _a[1];
    var _b = (0, react_1.useState)(""), username = _b[0], setUsername = _b[1];
    var _c = (0, react_1.useState)(""), password = _c[0], setPassword = _c[1];
    var _d = (0, react_1.useState)(false), snackbarOpen = _d[0], setSnackbarOpen = _d[1];
    var _e = (0, react_1.useState)(false), alternativeLoginOpen = _e[0], setAlternativeLoginOpen = _e[1];
    var classes = useStyles();
    var onSubmitHandler = function (event) { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    setError("");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, aws_amplify_1.Auth.signIn(username, password)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setError("Incorrect username or password");
                    setSnackbarOpen(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var federatedSignIn = function () {
        aws_amplify_1.Auth.federatedSignIn({ customProvider: "ST-AzureAD" });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_ui_1.Background, null),
        react_1.default.createElement("div", { className: classes.signIn },
            react_1.default.createElement(react_ui_1.Paper, { elevation: 15, withPadding: true },
                react_1.default.createElement("p", null,
                    react_1.default.createElement(react_ui_1.SportThiemeLogo, { className: classes.logo })),
                react_1.default.createElement(react_ui_1.Button, { color: "secondary", fullWidth: true, onClick: federatedSignIn },
                    react_1.default.createElement("img", { src: "https://pimage.sport-thieme.de/icon32/microsoft", className: classes.microsoftLogo, alt: "Microsoft Logo" }),
                    language.signInWithOffice),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(react_ui_1.Accordion, { expanded: alternativeLoginOpen, onChange: function () {
                            setAlternativeLoginOpen(!alternativeLoginOpen);
                        } },
                        react_1.default.createElement(react_ui_1.AccordionSummary, { expandIcon: react_1.default.createElement(react_ui_1.Icon.Person, null) },
                            react_1.default.createElement(react_ui_1.P, null, (0, util_localization_1.localize)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["login with external credentials"], ["login with external credentials"]))))),
                        react_1.default.createElement(react_ui_1.AccordionDetails, null,
                            react_1.default.createElement(react_ui_1.Grid, { item: true, xs: 12 },
                                react_1.default.createElement("form", { onSubmit: onSubmitHandler },
                                    error && (react_1.default.createElement(react_ui_1.SimpleSnackbar, { error: error, open: snackbarOpen, onClose: function () { return setSnackbarOpen(false); } })),
                                    react_1.default.createElement(react_ui_1.TextField, { required: true, value: username, onChange: function (e) { return setUsername(e.target.value); }, type: "email", label: "Username" }),
                                    react_1.default.createElement("p", null),
                                    react_1.default.createElement(react_ui_1.TextField, { required: true, value: password, onChange: function (e) { return setPassword(e.target.value); }, type: "password", label: "Password" }),
                                    react_1.default.createElement("p", null,
                                        react_1.default.createElement(react_ui_1.Button, { fullWidth: true, type: "submit" }, language.signIn)))))))))));
}
exports.default = SignIn;
var useStyles = (0, react_ui_1.makeStyles)({
    signIn: {
        zIndex: 1,
        position: "relative",
        top: "50vh",
        transform: "translateY(-50%)",
        margin: "0 auto",
        textAlign: "center",
        maxWidth: "395px",
        "& img.logo": {
            maxWidth: "100%",
            marginBottom: "20px",
        },
    },
    microsoftLogo: {
        height: "24px",
        marginRight: "10px",
    },
    logo: {
        width: "90%",
        marginBottom: 20,
    },
});
var templateObject_1;
//# sourceMappingURL=SignIn.js.map